/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFlightIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-flight"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.65 14.22L3.25 16.75Q2.5 17.05 1.85 16.6Q1.2 16.15 1.2 15.35L1.2 14.7Q1.2 14.32 1.38 13.99Q1.55 13.65 1.85 13.45L9.65 8.03L9.65 3.55Q9.65 2.58 10.34 1.89Q11.03 1.2 12 1.2Q12.97 1.2 13.68 1.89Q14.38 2.58 14.38 3.55L14.38 8.03L22.18 13.45Q22.48 13.65 22.65 13.99Q22.82 14.32 22.82 14.7L22.82 15.35Q22.82 16.15 22.18 16.6Q21.52 17.05 20.77 16.75L14.38 14.22L14.35 17.48L16.98 19.3Q17.25 19.5 17.39 19.76Q17.52 20.02 17.52 20.35L17.52 21.07Q17.52 21.73 17.01 22.11Q16.5 22.5 15.88 22.3L12 21.15L8.13 22.3Q7.5 22.5 6.99 22.11Q6.47 21.73 6.47 21.07L6.47 20.35Q6.47 20.02 6.61 19.76Q6.75 19.5 7.03 19.3L9.65 17.48Z" fill={color} />
    </svg>
  );
}
